/**
 * StarRating - Componente de calificación con estrellas
 * 
 * Muestra una calificación de 1-5 estrellas, con opción de ser editable.
 */

import { Star } from 'lucide-react';

const StarRating = ({ rating, onRate, editable = false }) => {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={`w-4 h-4 ${
            star <= rating ? "fill-amber-400 text-amber-400" : "text-gray-300"
          } ${editable ? "cursor-pointer hover:scale-110 transition-transform" : ""}`}
          onClick={() => editable && onRate && onRate(star === rating ? 0 : star)}
        />
      ))}
    </div>
  );
};

export default StarRating;
